import React, {useEffect } from 'react';
import { motion } from 'framer-motion';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useMediaQuery, useTheme } from '@mui/material';
import { useSessionstorageState } from 'rooks';

const ArrowAlert = () => {
  
 // Uncomment this when you are ready to use local storage
  const [hasShown, setHasShown] = useSessionstorageState('excelsior:arrow-alert-shown-bool', false);

  // For testing purposes
  // const [hasShown, setHasShown] = useState(false);

  const isDesktop = useMediaQuery('(min-width:768px)');
  const theme = useTheme();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isDesktop && !hasShown) {
      setTimeout(() => setHasShown(true), 10000); // Hide the component after 10 seconds
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktop, hasShown]);


  if (!isDesktop || hasShown) return null;

  return (
    <motion.div
      initial={{ y: '100%' }} // Start from below the screen
      animate={{ y: 0 }} // Move up to stick to the bottom
      exit={{ y: '100%' }} // Move down to exit
      style={{
        position: 'fixed',
        bottom: 0,
        zIndex: 9999,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: '1rem',
      }}
    >
      <ArrowBackIcon />
      <span>Use arrow keys or the menu to advance panels and pages</span>
      <ArrowForwardIcon />
    </motion.div>
  );
};

export default ArrowAlert;
